import { sortBy, isNil } from 'lodash'
import moment from 'moment'

export const slotIsPast = (slot) => moment(slot.startTime).isBefore()

export const sortTimeslots = slots => 
    sortBy(slots, slot => isNil(slot.startTime) ? null : moment(slot.startTime).format())
